"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "MegChartsBarList", {
  enumerable: true,
  get: function get() {
    return _barlist["default"];
  }
});
Object.defineProperty(exports, "MegChartsStatistics", {
  enumerable: true,
  get: function get() {
    return _statistics["default"];
  }
});
Object.defineProperty(exports, "MegChartsCentrallist", {
  enumerable: true,
  get: function get() {
    return _centrallist["default"];
  }
});
Object.defineProperty(exports, "MegPie", {
  enumerable: true,
  get: function get() {
    return _pie["default"];
  }
});
Object.defineProperty(exports, "MegChartsLine", {
  enumerable: true,
  get: function get() {
    return _line["default"];
  }
});
Object.defineProperty(exports, "MegChartsRadar", {
  enumerable: true,
  get: function get() {
    return _radar["default"];
  }
});
Object.defineProperty(exports, "MegChartsBar", {
  enumerable: true,
  get: function get() {
    return _bar["default"];
  }
});
Object.defineProperty(exports, "MegChartsGauge", {
  enumerable: true,
  get: function get() {
    return _gauge["default"];
  }
});
Object.defineProperty(exports, "MegChartsPanel", {
  enumerable: true,
  get: function get() {
    return _panel["default"];
  }
});
Object.defineProperty(exports, "MegChartsFunnel", {
  enumerable: true,
  get: function get() {
    return _funnel["default"];
  }
});
Object.defineProperty(exports, "MegChartsArea", {
  enumerable: true,
  get: function get() {
    return _area["default"];
  }
});
Object.defineProperty(exports, "MegRing", {
  enumerable: true,
  get: function get() {
    return _ring["default"];
  }
});
Object.defineProperty(exports, "MegChartsMini", {
  enumerable: true,
  get: function get() {
    return _mini["default"];
  }
});
Object.defineProperty(exports, "MegChartsLiquid", {
  enumerable: true,
  get: function get() {
    return _liquid["default"];
  }
});
exports["default"] = void 0;

var _barlist = _interopRequireDefault(require("./barlist"));

var _statistics = _interopRequireDefault(require("./statistics"));

var _centrallist = _interopRequireDefault(require("./centrallist"));

var _pie = _interopRequireDefault(require("./pie"));

var _line = _interopRequireDefault(require("./line"));

var _radar = _interopRequireDefault(require("./radar"));

var _bar = _interopRequireDefault(require("./bar"));

var _gauge = _interopRequireDefault(require("./gauge"));

var _panel = _interopRequireDefault(require("./panel"));

var _funnel = _interopRequireDefault(require("./funnel"));

var _area = _interopRequireDefault(require("./area"));

var _ring = _interopRequireDefault(require("./ring"));

var _mini = _interopRequireDefault(require("./mini"));

var _liquid = _interopRequireDefault(require("./liquid"));

var _common = require("./common");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var components = [_barlist["default"], _statistics["default"], _centrallist["default"], _pie["default"], _ring["default"], _line["default"], _radar["default"], _bar["default"], _gauge["default"], _panel["default"], _funnel["default"], _area["default"], _mini["default"], _liquid["default"]];

var install = function install(Vue) {
  // eslint-disable-next-line array-callback-return
  components.map(function (component) {
    Vue.use(component);
  }); //引入基本模板

  var echarts = require('echarts/lib/echarts'); // 引入折线图等组件


  require('echarts/lib/chart/line');

  require('echarts/lib/chart/bar');

  require('echarts/lib/chart/radar');

  require('echarts/lib/chart/funnel');

  require('echarts/lib/chart/gauge');

  require('echarts/lib/chart/pie');

  require('echarts-liquidfill/src/liquidFill'); // 引入提示框和title组件，图例


  require('echarts/lib/component/tooltip');

  require('echarts/lib/component/title');

  require('echarts/lib/component/legend');

  require('echarts/lib/component/legendScroll'); //图例翻译滚动


  require('echarts/lib/component/dataZoom'); // 图例下方slider


  require('echarts/lib/component/markLine'); // 图例平均线markline


  Vue.prototype.$echarts = echarts;
  Vue.prototype.$themeColor = _common.themeColor;
  Vue.prototype.$defaultColor = _common.defaultColor;
};

var _default = install;
exports["default"] = _default;